<template>
    <div class="mt-md w-full md:w-2/4 relative">
        <input
            class="form__input h-lg form__input--filled"
            @keyup.down.prevent="onArrowDown()"
            @keyup.up.prevent="onArrowUp()"
            autofocus
            v-on:keyup.enter="onEnter"
            @focus="show = true"
            v-model="searchInput"
            @keyup="getRecipes"
            type="text"
            :placeholder="placeholder"
        />
        <div class="absolute right-sm top-1/2 -translate-y-1/2 text-gray-600 hover:text-gray-700 cursor-pointer" @click.prevent="goTo">
            <i class="fa-regular fa-search"></i>
        </div>

        <div :key="`${selectedIndex}/${hoverinIndex}`" class="absolute left-0 w-full top-lg h-auto overflow-y-auto bg-gray-200" v-click-outside="hideDropdown" v-show="recipes.length > 0 && show">
            <div @mouseover="setIndex(index)" @mouseleave="clearIndex()" v-for="(item, index) in recipes" :key="index">
                <a
                    :class="{ 'bg-gray-300 !font-bold': hoverinIndex === index || (index === selectedIndex && hoverinIndex === -1) }"
                    class="flex items-center justify-between py-xs border-b border-gray-200 text-gray-600 text-sm px-sm font-normal"
                    :href="`${possibleLangPrefix}/recepten/${item.slug}`"
                >
                    {{ item.title }}
                    <i v-if="hoverinIndex === index || (index === selectedIndex && hoverinIndex === -1)" class="fa-regular fa-arrow-right"></i>
                </a>
            </div>
            <div @mouseover="setIndex(3)" @mouseleave="clearIndex()" v-if="recipes && recipes.length >= 3">
                <a
                    :class="{ 'font-bold': hoverinIndex === 3 || (3 === selectedIndex && hoverinIndex === -1) }"
                    class="flex items-center bg-gray-300 justify-between py-xs border-b border-gray-200 text-gray-600 text-sm px-sm"
                    :href="`${possibleLangPrefix}/recepten?s=${this.searchInput}`"
                >
                    Bekijk alle zoekresultaten
                    <i v-if="hoverinIndex === 3 || (3 === selectedIndex && hoverinIndex === -1)" class="fa-regular fa-arrow-right"></i>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import ClickOutside from 'vue-click-outside';
import translate from 'translate';
translate.key = process.env.MIX_GOOGLE_TRANSLATE_API_KEY;
import { debounce } from 'lodash';

export default {
    name: 'recipesearch',
    props: ['placeholder'],

    directives: {
        ClickOutside,
    },

    data() {
        return {
            params: {
                per_page: 3,
                after: 0,
            },
            loading: false,
            recipes: [],
            searchInput: '',
            show: false,
            selectedIndex: -1,
            hoverinIndex: -1,
        };
    },

    async mounted() {
        this.popupItem = this.$el;
    },

    methods: {
        getRecipes: debounce(async function () {
            this.loading = true;
            const self = this;

            if (document.documentElement.lang !== 'nl') {
                const text = await translate(this.searchInput, 'nl');
                this.searchRecipes(text);
            } else {
                this.searchRecipes(this.searchInput);
            }
        }, 500),

        searchRecipes(query) {
            if (query !== '') {
                this.params['q[title]'] = `like:*${query}*`;
                this.params['q[description]'] = `like:*${query}*`;

                axios
                    .get('/api/my-recipes', { params: { ...this.params } })
                    .then((response) => {
                        if (response.status === 200) {
                            this.recipes = response.data.data;
                        } else {
                            this.recipes = [];
                        }
                    })
                    .finally(() => (this.loading = false));
            } else {
                this.recipes = [];
            }
        },

        onEnter() {
            this.goTo();
        },

        onArrowDown() {
            if (this.recipes && this.recipes.length) {
                if ((this.recipes.length === 3 && this.selectedIndex === 3) || (this.recipes.length < 3 && this.selectedIndex + 1 === this.recipes.length)) {
                    this.selectedIndex = 0;
                } else {
                    this.selectedIndex++;
                }
            }
        },

        onArrowUp() {
            if (this.recipes && this.recipes.length) {
                if (this.selectedIndex <= 0) {
                    if (this.recipes.length < 3) {
                        this.selectedIndex = this.recipes.length - 1;
                    } else {
                        this.selectedIndex = 3;
                    }
                } else {
                    this.selectedIndex--;
                }
            }
        },

        goTo() {
            if (this.recipes && this.recipes.length && this.selectedIndex >= 0 && this.selectedIndex < this.recipes.length) {
                window.location = `/recepten/${this.recipes[this.selectedIndex].slug}`;
            } else {
                window.location = `/recepten?s=${this.searchInput}`;
            }
        },

        hideDropdown() {
            this.show = false;
        },

        setIndex(index) {
            if (!document.documentElement.classList.contains('touch')) {
                this.hoverinIndex = index;
            }
        },

        clearIndex() {
            if (!document.documentElement.classList.contains('touch')) {
                this.hoverinIndex = -1;
            }
        },
    },

    computed: {
        possibleLangPrefix() {
            // prefix with lang other than nl for correct Weglot translations
            return document.documentElement.lang !== 'nl' ? `/${document.documentElement.lang}` : '';
        },
    },
};
</script>
